import { checkboxAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  checkboxAnatomy.keys,
);

const circular = definePartsStyle({
  control: {
    rounded: 'full',
  },
  icon: {
    p: '1px',
  },
});

export default defineMultiStyleConfig({
  variants: {
    circular,
  },
});
